import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

// Detect the default locale from your Redux state or fallback
const defaultLocale = 'en-CA';

// Convert your translations object to i18next format if needed
const resources = Object.keys(translations).reduce((acc, locale) => {
  acc[locale] = { translation: translations[locale] };
  return acc;
}, {});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLocale,
    fallbackLng: 'en-CA',
    interpolation: {
      escapeValue: false, // React already escapes
      prefix: '%{', 
      suffix: '}',
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
